import { ACCESS_TOKEN } from 'shared/constants/cookies';
import { cookies } from 'shared/utils/storage/cookies';
import { local } from 'shared/utils/storage/local-storage';
import { isUsingMock } from './mock';

export const isUsingImpersonation = Boolean(
  (isUsingMock && local.get('mocksetting_impersonation')) ||
    cookies.get(ACCESS_TOKEN, true)?.includes('Issuer=yspro-customer-agent-impersonation-prod-v1'),
);
